import React from 'react'
import Categories from './Categories';
import Cta from './Cta';
import Section from './Section';
import MetaTags from '../../../helpers/Common/MetaTags';
import { getMetaConfig } from '../../../helpers/Common/metaConfig';

const JobsCategories = () => {
    const jobCategoriesMeta = getMetaConfig('jobCategories');
    
    return (
        <React.Fragment>
            <MetaTags {...jobCategoriesMeta} />
            <Section/>
            <Categories/>
            <Cta/>
        </React.Fragment>
    )
}

export default JobsCategories;
